import React from 'react';
import BaseBanner from '../core/BaseBanner';
import BannerWithDismissal from '../core/BannerWithDismissal';
import { DismissibleBannerProps } from '../types';
import { useThemeContext } from 'contexts/theme';
import { isTenantExpUS } from '@tenants/utils/which-tenant';

interface FloatingBannerProps extends DismissibleBannerProps {
  onButtonClick?: () => void;
}

const FloatingBanner: React.FC<FloatingBannerProps> = props => {
  const { theme: appTheme } = useThemeContext();
  const isExpUSTenant = props.tenantId ? isTenantExpUS(props.tenantId) : false;

  const floatingBannerSx = {
    position: 'relative',
    boxShadow: isExpUSTenant ? appTheme.decorations.boxShadow : '0px 4px 12px rgba(0, 0, 0, 0.1)',
    width: '90vw',

    '@media (min-width: 768px)': {
      width: 'auto',
      minWidth: '50vw',
      maxWidth: '800px',
    },
  };

  return (
    <BannerWithDismissal {...props}>
      {({ isDismissed, onDismiss, actionButton }) => {
        if (isDismissed) return null;

        const isDismissible = !props.persistent;

        return (
          <BaseBanner
            {...props}
            onDismiss={onDismiss}
            showCloseButton={isDismissible}
            actionButton={actionButton}
            sx={floatingBannerSx}
          />
        );
      }}
    </BannerWithDismissal>
  );
};

export default FloatingBanner;